/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 26.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";

import BaseContainer from "../../containers/BaseContainer";
import {SessionStore, SessionActions} from "../../services/Session";
import SelectRoleModal from "./SelectRoleModal";
import {NotificationActions} from "../../services/Notification";

class SelectRoleContainer extends BaseContainer {
    static propTypes = {
        /**
         * Set true to indicate that role selection is required
         */
        isRequired: PropTypes.bool,
        /**
         * Use specified authentication token
         */
        authToken: PropTypes.string,
        /**
         * onClose(roleSelected);
         */
        onClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        isRequired: false
    };

    constructor(props) {
        super(props, {
            session: SessionStore
        });
        /**
         * @typedef {Object} SelectRoleState
         * @member {SessionState} session
         */
        /**
         * @member {SelectRoleState} state
         */
        //
        this.state.newValue = {
            activeRole: (this.state.session.currentRecord && this.state.session.currentRecord.activeRole ?
                this.state.session.currentRecord.activeRole.id : null),
            isDefault: true
        };
        this.state.closeOnSave = false;
        this.onClose = this.onClose.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    /**
     *
     * @param {string} key
     * @param {SessionState} newState
     */
    loadingFinished(key, newState) {
        if (this.state.closeOnSave) {
            if (!this.props.isRequired || (newState.currentRecord && newState.currentRecord.activeRole && newState.currentRecord.activeRole.id == this.state.newValue.activeRole)) {
                this.props.onClose(true);
                return;
            }
            this.setState({closeOnSave: false});
        }
        let activeRole = null;
        if (newState.currentRecord && newState.currentRecord.activeRole)
            activeRole = newState.currentRecord.activeRole.id;
        this.setState({
            newValue: {
                activeRole: activeRole,
                isDefault: this.state.newValue.isDefault
            }
        });
    }

    /**
     * Called when specified store fails to load data.
     * By default this method uses notification to display error.
     * @param key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFailed(key, newState) {
        NotificationActions.actionError.defer(newState.action);
    }

    onClose(selectClicked) {
        if (selectClicked) {
            if (this.state.newValue.activeRole != this.state.session.currentRecord.activeRole.id) {
                // Switch to new role
                this.setState({
                    closeOnSave: true
                });
                let request = {
                    activeRole: {
                        id: this.state.newValue.activeRole
                    }
                };
                if (this.props.authToken) request.authToken = this.props.authToken;
                SessionActions.put(this.state.session.currentRecord.id, request);

            } else {
                // Selected value is already active. Just close:
                this.props.onClose(true);
            }
        } else {
            if (this.props.isRequired) return;
            this.props.onClose(false);
        }
    }

    /**
     *
     * @param field Changed field: "activeRole" or "isDefault"
     * @param value
     */
    onChange(field, value) {
        let newValue = {
            activeRole: this.state.newValue.activeRole,
            isDefault: this.state.newValue.isDefault
        }
        newValue[field] = value;
        this.setState({
            newValue: newValue
        });
    }

    /**
     * @typedef {Object} UserRole
     * @property {string} id
     * @property {string} organizationName
     * @property {string} roleName
     */

    /**
     * @returns {UserRole[] | null}
     */
    getRoles() {
        if (!this.state.session.currentRecord ||
            !this.state.session.currentRecord.person ||
            !this.state.session.currentRecord.person.personRoleCollection) return null;
        let roles = _.map(this.state.session.currentRecord.person.personRoleCollection.items,
            /**
             *
             * @param {PersonRole} item
             * @returns {Array}
             */
            function (item) {
                return {id: item.id, organizationName: item.organization.fullName, roleName: item.role.name};
            });

        return _.sortBy(roles, ['organizationName', 'roleName']);
    }

    getActiveRole() {
        return this.state.newValue.role;
    }

    render() {
        return (
            <SelectRoleModal
                roles={this.getRoles()}
                activeRole={this.state.newValue.activeRole}
                isDefault={this.state.newValue.isDefault}
                isRequired={this.props.isRequired}
                onChange={this.onChange}
                onClose={this.onClose}
            />
        );
    }
}

export default SelectRoleContainer;
